import { render, staticRenderFns } from "./Dilektra-CMS.vue?vue&type=template&id=79f944d2&"
import script from "./Dilektra-CMS.vue?vue&type=script&lang=js&"
export * from "./Dilektra-CMS.vue?vue&type=script&lang=js&"
import style0 from "./Dilektra-CMS.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports